import { css } from 'styled-components';

import { colors } from '../colors';
import type { ColorOptions } from './types';
import { colors as rawColors } from './raw';

export const colorVariables = css`
  ${Object.entries(colors).map(([token, value]) => {
    return `${value}: ${rawColors[token as ColorOptions]};`;
  })}
`;
